import { Component, OnInit } from '@angular/core';
import { AndroidService, Downloads } from './android.service';
import { Observable } from 'rxjs';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-android',
  templateUrl: './android.component.html',
  styleUrls: ['./android.component.css']
})
export class AndroidComponent implements OnInit {
  constructor(private androidService: AndroidService, private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  downloads = new Downloads();

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Mahanubhav Anvay App | sarvadhnya.com App | Andriod", 
    "Andriod Apps - Mahanubhav Anvay App will help you to deep down through litrature of Mahanubhav panth. Sarvadhnya app will give easy access to sarvadhnya.com website",
    "Mahanubhav Anvay app, sarvadhnya.com app, andriod app, mahanubhav andriod apps, mahanubhav sahitya app");

    this.androidService.get().subscribe(result => {
      this.downloads = result;
    });
  }

  download(app: number) {
    if (app == 3) {
      this.androidService.post(app).subscribe(result => {
        this.downloads = result;
      });;
      window.location.href = (window.location.origin + "/assets/apps/mahanubhav_anvay.apk");
    }
    if (app == 4) {
      this.androidService.post(app).subscribe(result => {
        this.downloads = result;
      });
      window.location.href = (window.location.origin + "/assets/apps/sarvadhnya.com.apk");
    }
  }
}
